import React from 'react';
import PropTypes from 'prop-types';
/**
 * Check Circle Icon comnponent
 *
 * @return {jsx}
 */

var CheckCircle = function CheckCircle(_ref) {
  var fill = _ref.fill;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.5 41.7a21.3 21.3 0 0 1-17.4 39A192 192 0 1 0 448 256v-19.6a21.3 21.3 0 0 1 42.7 0v19.6A234.7 234.7 0 1 1 351.5 41.7zm133 28.7a21.3 21.3 0 0 1 0 30.1L271 314.1a21.3 21.3 0 0 1-30.2 0l-64-64a21.3 21.3 0 1 1 30.2-30.2l48.9 49L454.2 70.3a21.3 21.3 0 0 1 30.2 0z",
    id: "circle"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "check",
    fill: "#fff",
    fillOpacity: "0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle"
  })), /*#__PURE__*/React.createElement("use", {
    fill: fill,
    fillRule: "nonzero",
    xlinkHref: "#circle"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#check)",
    fill: fill
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z"
  }))));
};
/**
 * PropTypes Validation
 */


var string = PropTypes.string;
CheckCircle.propTypes = {
  /**
   * Fill color
   */
  fill: string
};
/**
 * Default props.
 */

CheckCircle.defaultProps = {
  fill: 'white'
};
/**
 * Display name
 */

CheckCircle.displayName = 'CheckCircle';
export default CheckCircle;